'use client'

import HeaderGap from '@/components/atoms/headerGap'
import Layout from '@/components/templates/layout'
import CoverAnimation from '@/components/organisms/coverAnimation'
import Description from './components/description'
import Facilites from './components/facilities'

const RetreatPage = ({ retreatAPI, footerAPI, settingAPI }) => {
  return (
    <Layout settingAPI={settingAPI} footerAPI={footerAPI}>
      <HeaderGap />
      <CoverAnimation
        option={retreatAPI.cover.option}
        images={retreatAPI.cover.images}
        video={retreatAPI.cover.video}
        imagePlaceholder={retreatAPI.cover.imagePlaceholder}
        aspectRatio={retreatAPI.cover.aspectRatio}
        rowOne={retreatAPI.cover.title.rowOne}
        rowTwo={retreatAPI.cover.title.rowTwo}
      />
      <Description description={retreatAPI.description} />
      {retreatAPI.facilities.map((facility, id) => (
        <Facilites
          key={id}
          title={facility.title}
          banner={facility.banner}
          content={facility.content}
        />
      ))}
    </Layout>
  )
}

export default RetreatPage
